import React from 'react';
import  GraduationDay2024  from 'views/GraduationDay2024';
const AccountGeneralPage = () => {
  return <GraduationDay2024 />;
};
export default AccountGeneralPage;